document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll('.jobs-filter button');
	const jobs = document.querySelectorAll('.jobs-list .job');

	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const filterValue = button.dataset.filterLocation;

			buttons.forEach((btn) => {
				btn.classList.add('button--secondary');
			});

			button.classList.remove('button--secondary');

			jobs.forEach((job) => {
				const jobLocation = job.dataset.location;

				if (filterValue === '' || jobLocation === filterValue) {
					job.style.display = '';
				} else {
					job.style.display = 'none';
				}
			});
		});
	});
});
